<template>
  <van-tabs @click="onClick" v-model="active" type="card">
    <van-tab title="淘宝/天猫"></van-tab>
    <van-tab title="京东"></van-tab>
    <van-tab title="拼多多"></van-tab>
  </van-tabs>
</template>

<script>
export default {
  data() {
    return {
      active: 0
    };
  },
  created() {
    this.pathChange();
  },
  watch: {
    $route: "pathChange"
  },
  methods: {
    // 路由切换
    pathChange() {
      let path = this.$route.path;
      if (path === "/") {
        this.active = 0;
      } else if (path === "/jd") {
        this.active = 1;
      } else if (path === "/pdd") {
        this.active = 2;
      }
    },
    // 导航点击
    onClick(index, title) {
      if (title === "淘宝/天猫") {
        this.$router.push("/");
      } else if (title === "京东") {
        this.$router.push("/jd");
      } else if (title === "拼多多") {
        this.$router.push("/pdd");
      }
      this.active = index;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/headerTab.vue